import { IntlShape } from "react-intl"

export type TabTranslation = {
	id: string
	pathname: string
}

export type Tab = {
	text: string
	pathname: string
}

export const createTabs = (tabs: Array<TabTranslation>, intl: IntlShape) =>
	tabs.map(({ id, pathname }) => ({
		text: intl.formatMessage({ id }),
		pathname,
	}))
